export enum Environment {
    PRODUCTION,
    STAGE,
    DEV,
    LOCAL,
}